<div
  class="chatbot-composer d-flex flex-column align-items-stretch gap-2 px-3 py-2 border-top rounded-bottom-4 bg-white border-warning"
>
  <div
    v-if="show_compare_selector"
    class="chatbot-compare-drawer w-100"
    :class="{ 'is-open': is_compare_drawer_open }"
  >
    <button
      type="button"
      class="chatbot-compare-drawer-toggle d-flex align-items-center justify-content-between w-100 text-start gap-2 p-2 rounded-3 border bg-white text-dark"
      :disabled="disabled"
      :aria-expanded="is_compare_drawer_open ? 'true' : 'false'"
      aria-controls="chatbot-compare-drawer-panel"
      @click="toggle_compare_drawer"
    >
      <span class="chatbot-compare-drawer-title fw-bold d-inline-flex align-items-center gap-2 min-w-0 text-sm">
        <i class="bi bi-buildings text-warning" aria-hidden="true"></i>
        <span>Properties</span>
      </span>
      <span class="chatbot-compare-drawer-meta fw-bold text-nowrap d-inline-flex align-items-center gap-2 min-w-0 text-xs text-secondary">
        <span class="chatbot-compare-count d-inline-flex align-items-center rounded-pill py-1 px-2 text-dark bg-white border">{{ selected_compare_property_count_label }}</span>
        <i :class="is_compare_drawer_open ? 'bi bi-chevron-down' : 'bi bi-chevron-up'" aria-hidden="true"></i>
      </span>
    </button>

    <div
      v-if="is_compare_drawer_open"
      id="chatbot-compare-drawer-panel"
      class="chatbot-compare-drawer-panel d-flex flex-column gap-2 mt-2 p-2 border rounded-3 overflow-hidden bg-white text-dark"
    >
      <div class="chatbot-compare-drawer-actions d-flex align-items-center justify-content-between gap-2">
        <span class="chatbot-compare-drawer-summary overflow-hidden fw-semibold text-nowrap min-w-0 text-xs lh-sm text-secondary">{{ selected_compare_property_summary }}</span>
        <span class="d-inline-flex align-items-center gap-1">
          <button
            type="button"
            class="chatbot-compare-action-btn rounded-pill fw-bold lh-1 py-1 px-2 text-xxs text-dark bg-white border"
            :disabled="disabled || all_compare_properties_selected"
            @click="select_all_compare_properties"
          >
            All
          </button>
          <button
            type="button"
            class="chatbot-compare-action-btn rounded-pill fw-bold lh-1 py-1 px-2 text-xxs text-dark bg-white border"
            :disabled="disabled || !normalized_compare_property_ids().length"
            @click="clear_compare_properties"
          >
            Clear
          </button>
        </span>
      </div>

      <div class="chatbot-compare-property-grid d-grid overflow-y-auto gap-2 pe-1">
        <label
          v-for="property in compare_property_options"
          :key="property.id"
          class="chatbot-compare-property-option d-flex align-items-center m-0 gap-2 min-w-0 p-2 rounded-3 text-xs fw-bold lh-sm border bg-white text-dark"
          :class="{ 'is-selected': is_compare_property_selected(property.id) }"
          :for="`compare-property-${property.id}`"
        >
          <input
            class="form-check-input m-0"
            type="checkbox"
            :id="`compare-property-${property.id}`"
            :checked="is_compare_property_selected(property.id)"
            :disabled="disabled"
            @change="toggle_compare_property(property.id)"
          />
          <span>{{ property.label }}</span>
        </label>
      </div>
    </div>
  </div>

  <div class="d-flex align-items-center gap-2 w-100">
    <input
      type="text"
      :value="model_value"
      :disabled="disabled"
      @input="$emit('update:model_value', $event.target.value)"
      @keyup.enter="$emit('send')"
      class="
        form-control
        rounded-3
        shadow-none
      "
      :placeholder="placeholder"
    />

    <button
      class="btn btn-primary rounded-circle d-inline-flex align-items-center justify-content-center p-0 chatbot-send-btn"
      :disabled="disabled"
      @click="$emit('send')"
      aria-label="Send message"
    >
      <i class="bi bi-send-fill"></i>
    </button>
  </div>
</div>
